import { Typography } from "@mui/material";
import { hmLightTheme } from "../themes/hmTheme";

const HeaderLabelValue = ({ ...props }) => {
  let fontFamily =
    props?.fontFamily == "numberFontFamily"
      ? hmLightTheme?.palette?.numberFontFamily
      : hmLightTheme?.palette?.textFontFamily;

  if (props.type == "link") {
    return (
      <Typography
        variant="body2"
        color="black"
        component="a"
        href={props.linkto}
        target="_blank"
        rel="noreferrer"
        sx={{ color: "#00d6db" }}
        className={props?.className}
      >
        {props.value}
      </Typography>
    );
  } else {
    return (
      <Typography
        variant="body2"
        color="black"
        sx={{ fontFamily: fontFamily, textAlign: props?.textAlign || "left" }}
        className={props?.className}
      >
        {props.value}
      </Typography>
    );
  }
};

export default HeaderLabelValue;
